module.exports = __webpack_public_path__ + "static/media/lato-regular.18a9188a.woff";